import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GalleryItem } from './gallery.component';
import { environment } from '../../../environments/environment';


export interface GalleryReference {
  stats: { label: string; value: any }[];
  title: string;
}

export interface GallerySelectorOption {
  id: string;
  label: string;
}

export interface GallerySelector {
  type: 'unit' | 'floorplan' | 'property';
  label: string;
  selectedId: string;
  options: GallerySelectorOption[];
}

export interface GalleryResponse {
  items: GalleryItem[];
  reference: GalleryReference;
  selector: GallerySelector | null;
  visitor: {
    email: string;
    phone: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class GalleryService {
  constructor(private http: HttpClient) {}

  getGalleryItems(token: string, selectedId?: string): Observable<GalleryResponse> {
    let params = new HttpParams();

    if (selectedId) {
      params = params.set('selectedId', selectedId);
    }

    return this.http.get<GalleryResponse>(`${environment.baseUrl}gallery-token/${token}`, {
      params,
    });
  }
}
